// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4x-1";
export var standaloneTable = "_4x-0";